/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// CD CODE

    const timerDuration = 3 * 60 * 1000; 
    

    function startTimer() {
      const startTime = Date.now();
      localStorage.setItem('timerStart', startTime);
    
      updateTimer();
    }

    function updateTimer() {
      const timerDisplay = document.getElementById('timer');                      
      if (!timerDisplay) {
        console.error("Element with id 'timer' not found.");
        return; 
      }
    
      const startTime = parseInt(localStorage.getItem('timerStart'));
      const currentTime = Date.now();
      const timeElapsed = currentTime - startTime;
    
      if (timeElapsed < timerDuration) {
        const timeRemaining = timerDuration - timeElapsed;
        const minutes = Math.floor(timeRemaining / 1000 / 60);
        const seconds = Math.floor((timeRemaining / 1000) % 60).toString().padStart(2, '0');
    
        timerDisplay.textContent = `${minutes}:${seconds}`;
        requestAnimationFrame(updateTimer);
      } else {
  
        startTimer();
      }
    }

 setTimeout(function() {
    if (!localStorage.getItem('timerStart')) {
      startTimer();
    } else {
      updateTimer();
    }
}, 1500);


// Markets subfolder fix (Prestige v1 is pre-Markets and assumes root paths)
 (function () {
   var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
   if (root === '/') return; // German storefront: nothing to do

  // 1. Make the product form discoverable by the theme's root-anchored selector
   document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
     form.setAttribute('action', '/cart/add');
   });

  // 2. Re-prefix the theme's hardcoded cart requests onto the current market
   var prefix = function (url) {
     return (typeof url === 'string' && url.indexOf('/cart') === 0)
       ? root.replace(/\/$/, '') + url
       : url;
   };

   var fetch_ = window.fetch;
  window.fetch = function (input, init) {
     if (typeof input === 'string') input = prefix(input);
     else if (input && input.url) input = new Request(prefix(input.url), input);
     return fetch_.call(this, input, init);
   };

   var open_ = XMLHttpRequest.prototype.open;
   XMLHttpRequest.prototype.open = function (method, url) {
     arguments[1] = prefix(url);
     return open_.apply(this, arguments);
   };
 })();
